import axios from 'axios';

const submitReimbursementRequest = (csrfToken, formData, locale) => {
  return axios.post(
    `${
      locale === 'en_US' || locale === 'zh_CN' ? '' : `/${locale}`
    }/contactus/api/submit-reimbursement-form`,
    formData,
    {
      headers: {
        'CSRF-Token': csrfToken,
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
      },
    }
  );
};

export default submitReimbursementRequest;
